<template>
  <div>
    <v-layout justify-end>
      <v-btn @click.stop="addInstructorDialog = true" color="primary">Add Instructor</v-btn>
    </v-layout>

    <v-container grid-list-lg>
      <v-layout row wrap>
        <instructor-view @editInstructor="editInstructor" v-for="i in instructors" v-bind:key="i.id"
          v-bind:instructor="i"></instructor-view>
      </v-layout>
    </v-container>

    <v-dialog v-model="addInstructorDialog" max-width="700px">
      <v-card>
        <v-card-title>
          <h3>Add Instructor</h3>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-layout column>
              <v-flex>
                <v-text-field v-model="firstName" label="First Name" id="first" required></v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field v-model="lastName" label="Last Name" id="last" required></v-text-field>
              </v-flex>
              <v-flex>
                <v-textarea v-model="bio" label="Bio" id="bio" required></v-textarea>
              </v-flex>
              <v-flex>
                <v-text-field v-model="priority" type="number" label="Priority" id="priority" required></v-text-field>
              </v-flex>
              <v-flex>
                <v-btn raised color="primary" @click="onPickFile">Upload Image</v-btn>
                <input type="file" style="display:none;" ref="fileInput" accept="image/*" @change="onFilePicked">
              </v-flex>
              <v-flex>
                <img :src="imageUrl" height="150">
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" flat v-on:click="closeAddDialog">Close</v-btn>
          <v-btn color="success" v-on:click="addInstructor" :disabled="!isComplete">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions,
    mapMutations
  } from "vuex";
  import Instructor from "../../../store/models/Instructor.js";
  import InstructorView from "./InstructorView.vue";

  export default {
    components: {
      InstructorView
    },
    data() {
      return {
        addInstructorDialog: false,
        firstName: "",
        lastName: "",
        bio: "",
        priority: "",
        imageUrl: "",
        image: null
      };
    },
    computed: {
      ...mapGetters({
        loading: "getLoading",
        instructors: "getInstructors"
      }),
      ...mapMutations({
        instructorToEdit: ""
      }),
      isComplete() {
        return (
          this.firstName &&
          this.lastName &&
          this.bio &&
          this.imageUrl &&
          this.priority
        );
      }
    },
    methods: {
      onPickFile() {
        this.$refs.fileInput.click();
      },
      onFilePicked(event) {
        const files = event.target.files;
        let fileName = files[0].name;
        if (fileName.lastIndexOf(".") <= 0) {
          return alert("Please add a valid file.");
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.imageUrl = fileReader.result;
        });
        fileReader.readAsDataURL(files[0]);
        this.image = files[0];
      },
      addInstructor() {
        let id = 0;
        let instImage = this.image;

        let instructor = new Instructor(
          0,
          this.firstName,
          this.lastName,
          this.bio,
          this.priority,
          this.image,
          "",
          "",
          new Date().toISOString(),
          new Date().toISOString()
        );

        this.$store.dispatch("addInstructor", instructor);

        this.closeAddDialog();
      },
      editInstructor() {},
      closeAddDialog() {
        this.firstName = "";
        this.lastName = "";
        this.bio = "";
        this.priority = "";
        this.imageUrl = "";
        this.image = null;
        this.addInstructorDialog = false;
      }
    },
    created: function () {
      this.$store.dispatch("getAllInstructors");
    }
  };
</script>